import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";
import "./css/styles.css";
import Login from "./pages/Login";
import Home2 from "./pages/Home2";
import LiveFeed from "./pages/LiveFeed";
import TeamReg from "./pages/TeamReg";
import AnglerDetails from "./pages/AnglerDetails";
import TeamDetails from "./pages/TeamDetails";
import VideoPlayer from "./pages/VideoPlayer";
import VideoPlayerPhone from "./pages/VideoPlayerPhone";
import VideoUploader from "./pages/VideoUploader";
import Bisbeesbnb from "./pages/tournaments/Bisbeesbnb"
import BisbeesLosCabos from "./pages/tournaments/BisbeesLosCabos"
import PelagicQuepos from "./pages/tournaments/PelagicQuepos"
import Pescadora from "./pages/tournaments/pescadora/Pescadora"
import Pescadora2 from "./pages/tournaments/pescadora/Pescadora2"
import PescadoraLogs from "./pages/tournaments/pescadora/PescadoraLogs"
import RoosterRodeo from "./pages/tournaments/roosterrodeo/RoosterRodeo"
import RoosterRodeo2 from "./pages/tournaments/roosterrodeo/RoosterRodeo2"
import PelagicTuna from "./pages/tournaments/PelagicTuna"
import Ppv from "./pages/tournaments/pelagicPV/Ppv"
import Irt19 from "./pages/tournaments/pelagicPV/Irt19"
import Ppvjr from "./pages/tournaments/pelagicPV/Ppvjr"
import Ptc from "./pages/tournaments/ptc/Ptc"
import Qbc from "./pages/tournaments/qbc/Qbc"
import Mpv from "./pages/tournaments/qbc/Mpv"
import MpvOpen2019 from "./pages/tournaments/MpvOpen2019"
import DoradoDerby from "./pages/tournaments/DoradoDerby"
import BarbaRoja from "./pages/restaurants/BarbaRoja"
import Runaway from "./pages/restaurants/Runaway"
import DoubleHook from "./pages/restaurants/DoubleHook"
import BlueMarlinBar from "./pages/restaurants/BlueMarlinBar"
import BajaCantina from "./pages/restaurants/BajaCantina"
import Fishermans from "./pages/restaurants/Fishermans"
import CaptTonys from "./pages/restaurants/CaptTonys"
import Cabo from "./pages/destinations/Cabo"

class App extends Component {
  render() {
    return (
      <BrowserRouter>
      <div>
        <Route path="/" component={Home2} exact/>
        <Route path="/livefeed" component={LiveFeed} name="Live Feed"/>
        <Route 
          path="/anglerdetails/:anglerId" 
          render= { (props) => <AnglerDetails {...props}/> }
          name="Angler Details" />
        <Route 
          path="/teamdetails/:teamId" 
          render= { (props) => <TeamDetails {...props}/> }
          name="Team Details" />
        <Route 
          path="/teamreg/:tourId" 
          render= { (props) => <TeamReg {...props}/> }
          name="Team Registration" />
        <Route 
          path="/login/:tourId" 
          render= { (props) => <Login {...props}/> }
          name="Login" />
				<Route path="/videouploader" component={VideoUploader} name="Video Uploader" />
        <Route path="/videoplayer" component={VideoPlayer} name="Quepos, Costa Rica" />
				<Route path="/videoplayerphone" component={VideoPlayerPhone} name="Quepos, Costa Rica" />
        <Route path="/bisbeesbnb" component={Bisbeesbnb} name="Bisbees Black & Blue" />
        <Route path="/bisbeesloscabos" component={BisbeesLosCabos} name="Bisbees Black & Blue" />
				<Route path="/mpvopen2019" component={MpvOpen2019} name="Marina Pez Vela 2019" />
        <Route path="/pelagicquepos" component={PelagicQuepos} name="Pelagic Rockstar Costa Rica" />
        <Route path="/pescadora" component={Pescadora} name="Pescadora" />
        <Route path="/pescadora2" component={Pescadora2} name="Pescadora" />
        <Route path="/pescadoralogs" component={PescadoraLogs} name="Pescadora Logs" />
        <Route path="/roosterrodeo" component={RoosterRodeo} name="Roosterfish Rodeo" />
        <Route path="/roosterrodeo2" component={RoosterRodeo2} name="Roosterfish Rodeo" />
        <Route path="/pelagictuna" component={PelagicTuna} name="Pelagic Rockstar Tuna" />
				<Route path="/qbc" component={Qbc} name="Qbc" />
				<Route path="/ppv" component={Ppv} name="Ppv" />
				<Route path="/irt19" component={Irt19} name="Irt19" />
				<Route path="/ppvjr" component={Ppvjr} name="Ppvjr" />
				<Route path="/ptc" component={Ptc} name="Ptc" />
				<Route path="/mpv" component={Mpv} name="MPV Open" />
        <Route path="/doradoderby" component={DoradoDerby} name="MPV Dorado Derby" />
        <Route path="/bajacantina" component={BajaCantina} name="Baja Cantina" />
				<Route path="/doublehook" component={DoubleHook} name="Double Hook" />
				<Route path="/runaway" component={Runaway} name="Runaway" />
				<Route path="/barbaroja" component={BarbaRoja} name="Barba Roja" />
				<Route path="/bluemarlinbar" component={BlueMarlinBar} name="Blue Marlin Bar" />
        <Route path="/fishermans" component={Fishermans} name="Fishermans" />
        <Route path="/capttonys" component={CaptTonys} name="Captain Tony's" />
        <Route path="/cabo" component={Cabo} name="Los Cabos, Mexico" />
      </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js